var React = require('react');

function IconRoundUser (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"50.5","cy":"50","r":"50","fill":"white","key":0}),React.createElement("path",{"d":"M58.889 54C65.566 54 71 59.832 71 67C71 67.553 70.553 68 70 68C69.447 68 69 67.553 69 67C69 60.935 64.464 56 58.889 56H41.111C35.536 56 31 60.935 31 67C31 67.553 30.553 68 30 68C29.447 68 29 67.553 29 67C29 59.832 34.434 54 41.111 54H58.889ZM50 27C56.617 27 62 32.383 62 39C62 45.617 56.617 51 50 51C43.383 51 38 45.617 38 39C38 32.383 43.383 27 50 27ZM50 29C44.486 29 40 33.486 40 39C40 44.514 44.486 49 50 49C55.514 49 60 44.514 60 39C60 33.486 55.514 29 50 29Z","fill":"#414141","key":1})]);
}

IconRoundUser.defaultProps = {"width":"101","height":"100","viewBox":"0 0 101 100","fill":"none"};

module.exports = IconRoundUser;

IconRoundUser.default = IconRoundUser;
